// All native API frequencies must remain displayable, including options created by MCP.
export const paymentScheduleFrequencies = Object.freeze({
  MONTHLY: { name: 'Mensuel', description: 'tous les 30 jours', i18nKey: 'monthly' },
  EVERY_TWO_WEEKS: { name: 'Bimensuel', description: 'tous les 14 jours', i18nKey: 'biweekly' },
  WEEKLY: { name: 'Hebdomadaire', description: 'tous les 7 jours', i18nKey: 'weekly' },
  EVERY_TWO_MONTHS: { name: 'Tous les deux mois', description: 'tous les 2 mois', i18nKey: 'bimonthly' },
  QUARTERLY: { name: 'Trimestriel', description: 'tous les 3 mois', i18nKey: 'quarterly' },
  SEMESTERLY: { name: 'Semestriel', description: 'tous les 6 mois', i18nKey: 'semesterly' },
  YEARLY: { name: 'Annuel', description: 'tous les ans', i18nKey: 'yearly' },
});

// Preserve the existing native creation choices; display supports the full API contract.
export const paymentScheduleChoices = {
  MONTHLY: paymentScheduleFrequencies.MONTHLY,
  EVERY_TWO_WEEKS: paymentScheduleFrequencies.EVERY_TWO_WEEKS,
  WEEKLY: paymentScheduleFrequencies.WEEKLY,
};

export const describePaymentScheduleFrequency = (frequency) => (
  paymentScheduleFrequencies[frequency] ? paymentScheduleFrequencies[frequency].description : frequency
);
